export const MESSAGE_STORE = "MESSAGE_STORE";

/********************************  State ********************************/
export const CONVERSATION_MESSAGES = "CONVERSATION_MESSAGES";
export const CONVERSATION_DETAIL = "CONVERSATION_DETAIL";

/********************************  Getters ********************************/
export const GET_CONVERSATION_MESSAGES = "GET_CONVERSATION_MESSAGES";
export const GET_CONVERSATION_DETAIL = "GET_CONVERSATION_DETAIL";
export const GET_PARTICIPANT_DETAIL = "GET_PARTICIPANT_DETAIL";
export const GET_CURRENT_USER_STATUS = "GET_CURRENT_USER_STATUS";
/********************************  Mutations ********************************/
export const ADD_MESSAGE_MUTATION = "ADD_MESSAGE_MUTATION";
export const PREPEND_MESSAGE_MUTATION = "PREPEND_MESSAGE_MUTATION";
export const RESET_MESSAGES = "RESET_MESSAGES";
export const M_CONVERSATION_DETAIL = "M_CONVERSATION_DETAIL";

/********************************  Actions ********************************/
export const FETCH_MESSAGES = "FETCH_MESSAGES";
export const ADD_NEW_MESSAGE = "ADD_NEW_MESSAGE";
export const RESET_STORE = "RESET_STORE";
export const FETCH_CONVERSATION_DETAIL = "FETCH_CONVERSATION_DETAIL";
export const REJOIN_CONVERSATION = "REJOIN_CONVERSATION";
export const CONVERSATION_CHANGED = "CONVERSATION_CHANGED";
export const GET_CONVERSATION_CHANGED = "GET_CONVERSATION_CHANGED";
export const TOGGLE_CONVERSATION_CHANGED = "TOGGLE_CONVERSATION_CHANGED";
export const SMS_DATA_CHANGED = "SMS_DATA_CHANGED";
export const TOOGLE_CONVERSATION_ID = "TOOGLE_CONVERSATION_ID";
export const GET_TOGGLE_CONVERSATION_ID = "GET_TOGGLE_CONVERSATION_ID";
export const TOGGLE_CONVERSATION_CHANGED_ID = "TOGGLE_CONVERSATION_CHANGED_ID";
export const SMS_DATA_SELECTED_ID = "SMS_DATA_SELECTED_ID";
